package es.subastia.data.repository

import androidx.datastore.core.DataStore
import androidx.datastore.preferences.core.Preferences
import androidx.datastore.preferences.core.edit
import androidx.datastore.preferences.core.stringPreferencesKey

import es.subastia.data.mapper.toData
import es.subastia.data.mapper.toDomain
import es.subastia.data.model.AuctionTypeDataModel
import es.subastia.data.model.ProvinceDataModel
import es.subastia.domain.model.AuctionTypeDomainModel
import es.subastia.domain.model.ProvinceDomainModel
import es.subastia.domain.repository.UserRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class UserRepositoryImpl(private val dataStore: DataStore<Preferences>) : UserRepository {
    private val TYPE_KEY = stringPreferencesKey("user_type")
    private val PROCEDURE_TYPE_KEY = stringPreferencesKey("user_procedure_type")
    private val PROVINCE_KEY = stringPreferencesKey("user_province")


    override fun getSavedAuctionType(): Flow<AuctionTypeDomainModel?> {
        return dataStore.data.map { prefs ->
            val typeString = prefs[TYPE_KEY]
            if (typeString != null) {
                AuctionTypeDataModel.fromString(typeString)?.toDomain()
            } else {
                null
            }
        }
    }

    override fun getSavedAuctionProcedureType(): Flow<es.subastia.domain.model.AuctionProcedureType?> {
        return dataStore.data.map { prefs ->
            val typeString = prefs[PROCEDURE_TYPE_KEY]
            es.subastia.domain.model.AuctionProcedureType.fromString(typeString).takeIf { it != es.subastia.domain.model.AuctionProcedureType.UNKNOWN }
        }
    }

    override fun getSavedProvince(): Flow<ProvinceDomainModel?> {
        return dataStore.data.map { prefs ->
            val provinceString = prefs[PROVINCE_KEY]
            if (provinceString != null) {
                ProvinceDataModel.fromString(provinceString)?.toDomain()
            } else {
                null
            }
        }
    }


    override suspend fun saveAuctionType(type: AuctionTypeDomainModel?) {
        dataStore.edit { prefs ->
            if (type != null) {
                prefs[TYPE_KEY] = type.toData().text
            } else {
                prefs.remove(TYPE_KEY)
            }
        }
    }

    override suspend fun saveAuctionProcedureType(type: es.subastia.domain.model.AuctionProcedureType?) {
        dataStore.edit { prefs ->
            if (type != null) {
                prefs[PROCEDURE_TYPE_KEY] = type.label
            } else {
                prefs.remove(PROCEDURE_TYPE_KEY)
            }
        }
    }

    override suspend fun saveProvince(province: ProvinceDomainModel?) {
        dataStore.edit { prefs ->
            if (province != null) {
                prefs[PROVINCE_KEY] = province.toData().nm
            } else {
                prefs.remove(PROVINCE_KEY)
            }
        }
    }
}
